import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TemplateResponse } from 'src/app/shared/models/template-response';

@Injectable({
    providedIn: 'root'
})
export class TemplateApiService {
    templateUrlSuffix = '/v3/templates';
    baseUrl: string = environment.apiUrl;
    constructor(private httpClient: HttpClient) {}

    getTemplates() {
        const idSuffix = this.templateUrlSuffix;
        return this.httpClient.get<TemplateResponse[]>(`${this.baseUrl}${idSuffix}`);
    }

    getTemplate(templateId: number) {
        const idSuffix = this.templateUrlSuffix;
        return this.httpClient.get<TemplateResponse>(`${this.baseUrl}${idSuffix}/${templateId}`);
    }
}
